import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {getAllLabels, getLabelsWithCounts, deleteLabel} from "./API";

export const getLabelsThunk = createAsyncThunk(
    'songs/getLabels',
    async (spaceId) => {
        return getAllLabels(spaceId)
    }
)

export const getLabelsWithCountsThunk = createAsyncThunk(
    'labels/getLabelsWithCounts',
    async (spaceId) => {
        return getLabelsWithCounts(spaceId)
    }
)

export const deleteAndReassignLabelThunk = createAsyncThunk(
    'labels/deleteAndReassign',
    async (payload) => {
        const { spaceId, labelId, reassignToLabelId } = payload;
        return deleteLabel(spaceId, labelId, reassignToLabelId)
    }
)

const LabelsSlice = createSlice({
    name: 'labels',
    initialState: {labels: [], labelsWithCounts: [], loading: 'idle', status: 'idle'},
    reducers: {},
    extraReducers: {
        [getLabelsThunk.pending]: (state, action) => {
            state.status = 'loading'
        },
        [getLabelsThunk.rejected]: (state, action) => {
            state.status = 'failed'
            state.error = action.error.message
        },
        [getLabelsThunk.fulfilled]: (state, action) => {
            state.labels = action.payload
            state.status = 'idle'
        },
        [getLabelsWithCountsThunk.pending]: (state, action) => {
            state.status = 'loading'
        },
        [getLabelsWithCountsThunk.rejected]: (state, action) => {
            state.status = 'failed'
            state.error = action.error.message
        },
        [getLabelsWithCountsThunk.fulfilled]: (state, action) => {
            state.labelsWithCounts = action.payload
            state.status = 'idle'
        },
        [deleteAndReassignLabelThunk.pending]: (state, action) => {
            state.status = 'loading'
        },
        [deleteAndReassignLabelThunk.rejected]: (state, action) => {
            state.status = 'failed'
            state.error = action.error.message
        },
        [deleteAndReassignLabelThunk.fulfilled]: (state, action) => {
            state.status = 'idle'
        }
    }
})

export default LabelsSlice.reducer
